'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _iconSuccess = require('../icons/icon-success');

var _iconSuccess2 = _interopRequireDefault(_iconSuccess);

var _iconError = require('../icons/icon-error');

var _iconError2 = _interopRequireDefault(_iconError);

var _iconWarning = require('../icons/icon-warning');

var _iconWarning2 = _interopRequireDefault(_iconWarning);

var _iconInfo = require('../icons/icon-info');

var _iconInfo2 = _interopRequireDefault(_iconInfo);

var _iconClose = require('../icons/icon-close');

var _iconClose2 = _interopRequireDefault(_iconClose);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _darken = require('../internal/darken');

var _darken2 = _interopRequireDefault(_darken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var displayName = 'Alert';

var propTypes = {
  /** Text to display */
  text: _propTypes2.default.node.isRequired,
  /** Type of alert. One of the following: ["info", "success", "warning", "error"] */
  type: _propTypes2.default.oneOf(['success', 'error', 'warning', 'info']).isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the icon element */
  iconStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the text element */
  textStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the button element */
  buttonStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the close button is clicked
   *
   * function(event: object) => void
   */
  hideAlert: _propTypes2.default.func
};

var defaultProps = {
  style: {},
  iconStyle: {},
  textStyle: {},
  buttonStyle: {},
  hideAlert: null
};

var icons = {
  success: _react2.default.createElement(_iconSuccess2.default, { color: (0, _darken2.default)(_colors2.default.alert.success, 0.65) }),
  error: _react2.default.createElement(_iconError2.default, { color: (0, _darken2.default)(_colors2.default.alert.error, 0.65) }),
  warning: _react2.default.createElement(_iconWarning2.default, { color: (0, _darken2.default)(_colors2.default.alert.warning, 0.65) }),
  info: _react2.default.createElement(_iconInfo2.default, { color: (0, _darken2.default)(_colors2.default.alert.info, 0.65) })
};

/** Four types of (system) messages for alerting your user */
var Alert = function Alert(_ref) {
  var text = _ref.text,
      hideAlert = _ref.hideAlert,
      type = _ref.type,
      style = _ref.style,
      iconStyle = _ref.iconStyle,
      textStyle = _ref.textStyle,
      buttonStyle = _ref.buttonStyle,
      custom = _objectWithoutProperties(_ref, ['text', 'hideAlert', 'type', 'style', 'iconStyle', 'textStyle', 'buttonStyle']);

  return _react2.default.createElement(
    'section',
    _extends({ style: _getStyles2.default.root(type, style) }, custom),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.icon(iconStyle) },
      icons[type]
    ),
    _react2.default.createElement(
      'p',
      { style: _getStyles2.default.text(hideAlert, textStyle) },
      text
    ),
    hideAlert ? _react2.default.createElement(
      _button2.default,
      { iconButton: true, onClick: hideAlert, style: _getStyles2.default.button(buttonStyle) },
      _react2.default.createElement(_iconClose2.default, { color: (0, _darken2.default)(_colors2.default.alert[type], 0.65) })
    ) : null
  );
};

Alert.displayName = displayName;
Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

exports.default = Alert;
module.exports = exports.default;